// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"398":"b8b68b07","720":"8a2f7731","801":"070a6712"}[chunkId] + ".css";
};